import { CSSObject } from '@emotion/react';

/**
 * Adds hyphens to breaking words
 */
export const hyphenate: CSSObject = {
    wordBreak: 'break-word',
    hyphens: 'auto',
};
